import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    FormControl: {
        width: 550
    }
});

export const MSESelectGender = (props) => {
    const classes = useStyles();
    const {
        inputLabel,
        label,
        value,
        handleChange,
        disabled,
        nameValue,
        ...others
    } = props;
    const genders = [
        {value: 'H', display: 'Hombre'},
        {value: 'M', display: 'Mujer'},
    ];

    return (
        <FormControl className={classes.formControl}>
            <InputLabel>
                {inputLabel}
            </InputLabel>
            <Select
                labelId={`formcontrol-select-gender-${nameValue}`}
                id={`formcontrol-select-gender-${nameValue}`}
                value={value || ''}
                onChange={e => handleChange(nameValue,e)}
                required
                className={classes.FormControl}
            >
                {genders.map((gender, i) => <MenuItem value={gender.value} key={`f-s-mi-${nameValue}-${i}`}>{gender.display}</MenuItem>)}
            </Select>
        </FormControl>
    );
};